import { useState, useEffect } from 'react';
// import { useNavigate } from 'react-router-dom';
import { Heart } from 'lucide-react';
import CustomAppBar from '../../../mainComponents/appBar';
import { useUserUpdateMutation } from '../../../redux/setting';
import toast from "react-hot-toast";
import { useGetUserQuery } from '../../../redux/auth';

export default function TeamNglMessages() {
  // const navigate = useNavigate();
  const [enabled, setEnabled] = useState(false);
  
  const [updateNotificationSettings, { isLoading }] = useUserUpdateMutation();
  const { data: userData, isLoading: isLoadingUser } = useGetUserQuery();

  // Load settings from user data when available
  useEffect(() => {
    if (userData?.data) {
      const isEnabled = Boolean(Number(userData.data.receive_msg_from_ngl || 0)) as boolean;
      setEnabled(isEnabled);
    }
  }, [userData]);

 const handleToggle = async () => {
  const newValue = !enabled;

  try {
    const response = await updateNotificationSettings({
      receive_msg_from_ngl: newValue,
    }).unwrap();

    toast.success(response.message || "User Settings updated successfully");

    setEnabled(newValue);
  } catch (error) {
    console.error('Failed to update notification settings:', error);
    toast.error("Failed to update settings.");
  }
};


  return (
    <div className="flex justify-center bg-[#f5f5f5] overflow-hidden no-scrollbar pt-10 h-screen px-4 py-6 text-black font-[SF Pro Display]">
      <div className="w-full max-w-sm">
        {/* Header */}
        <CustomAppBar
          title="Team broChat Messages"
        />

        {/* Card */}
        <div className="bg-white mt-5 rounded-2xl p-5 space-y-4 shadow-md">
          <div className="flex items-start space-x-4">
            <div className="bg-pink-100 rounded-full p-2">
              <Heart className="w-5 h-5 text-pink-600" />
            </div>
            <div>
              <p className="font-bold text-[15px] text-gray-900">
                Team broChat sends you fun surprises 😋
              </p>
              <p className="text-sm text-gray-600 mt-1">
                You might get motivational notes, cute tips, or jokes!
              </p>
            </div>
          </div>

          {/* Toggle */}
          <div className="flex items-center justify-between mt-6">
            <span className="text-[15px] font-semibold text-gray-900">
              Allow messages from Team broChat
            </span>
            <label className="inline-flex items-center cursor-pointer">
              <input
                type="checkbox"
                className="sr-only"
                checked={enabled}
                onChange={handleToggle}
                disabled={isLoading}
              />
              <div
                className={`w-11 h-6 ${
                  enabled ? 'bg-green-500' : 'bg-gray-300'
                } rounded-full relative transition duration-200 ${
                  isLoading ? 'opacity-50 cursor-not-allowed' : ''
                }`}
              >
                <div
                  className={`absolute top-1 left-1 w-4 h-4 bg-white rounded-full shadow-md border transition-transform duration-200 ${
                    enabled ? 'translate-x-5' : ''
                  } ${isLoading ? 'animate-pulse' : ''}`}
                ></div>
              </div>
            </label>
          </div>

          <p className="text-xs text-gray-500 italic mt-1">
            We'll only send a few per week. No spam 💖
          </p>
        </div>

        {/* Emoji footer */}
        <div className="text-4xl text-center mt-10">✨💌✨</div>
      </div>
    </div>
  );
}